export default __webpack_public_path__ + "static/media/back.c5d20e45.svg";